import {USER_ROOT_API_URL} from "../../../../config/settings.js"

export const CHECK_USER_BLOCKED = USER_ROOT_API_URL +  "/check_user_blocked"
export const GET_PAST_POSTS = USER_ROOT_API_URL +  "/get_past_posts"
export const GET_POST_DATES = USER_ROOT_API_URL +  "/get_post_dates"